import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { SavedQuery, SavedQueryBody } from '@/entities/query/query-types';
import { socialApiClient } from '@/shared/api-client/social-api-client';
import { showErrorDialog } from '@/shared/utils/show-error-dialog';

async function updateQuery({
  workspaceId,
  queryId,
  filter,
  options,
}: {
  workspaceId: string;
  queryId: string;
} & Partial<SavedQueryBody>): Promise<SavedQuery> {
  const response = await socialApiClient.patch<SavedQuery>(
    `workspaces/${workspaceId}/queries/${queryId}`,
    {
      json: {
        filter,
        options,
      },
    },
  );

  return response.json();
}

export function useUpdateQuery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateQuery,
    onSuccess: (data, variables) => {
      // Invalidate saved queries list to reflect the update
      queryClient.invalidateQueries({
        queryKey: ['saved-queries', variables.workspaceId],
      });
      // Invalidate the specific query data
      queryClient.invalidateQueries({
        queryKey: ['query', variables.queryId],
      });
    },
    onError: (error) => {
      showErrorDialog({
        error,
        title: 'Failed to update query',
      });
    },
  });
}
